import { render } from "./MainReportProducts.vue?vue&type=template&id=3e43b9e2&scoped=true"
import script from "./MainReportProducts.vue?vue&type=script&lang=js"
export * from "./MainReportProducts.vue?vue&type=script&lang=js"

import "./MainReportProducts.vue?vue&type=style&index=0&id=3e43b9e2&scoped=true&lang=css"

import exportComponent from "D:\\facturacion electronica\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e43b9e2"]])

export default __exports__